import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { accessLocalStorage, readInterfaces } from '../../../services';
import TableInterfaces from './TableInterfaces';
import './InterfacesList.css';

function ListInterfaces() {
  const history = useHistory();
  const [interfaces, setInterfaces] = useState([]);
  const [fullDataIfaces, setFullDataIfaces] = useState({});

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const getNetworkData = await readInterfaces();
    const filterIfaces = getNetworkData.map((element) => {
      delete element['lo'];
      return element;
    });
    
    setInterfaces(Object.keys(...filterIfaces))
    setFullDataIfaces(...filterIfaces)
  }, []);

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="interfaces-list-container">
      <div className="interfaces-header">
        <div className="interfaces-title-wrapper">
          <svg className="interfaces-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
          </svg>
          <div>
            <h1 className="interfaces-title">Interfaces de Rede</h1>
            <p className="interfaces-subtitle">Visualize as interfaces de rede configuradas</p>
          </div>
        </div>
      </div>

      <div className="interfaces-table-wrapper">
        <table className="interfaces-table">
          <thead className="interfaces-table-header">
            <tr>
              <th>Nome</th>
              <th>MAC</th>
              <th>IP</th>
              <th>Status</th>
              <th>Conexão</th>
            </tr>
          </thead>
          <tbody>
            {
              Object.values(fullDataIfaces).length > 0 ? interfaces.map((call) => <TableInterfaces key={ call } iface={{ iface: call, ...fullDataIfaces[call] }} />) : null
            }
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ListInterfaces;
